export default __webpack_public_path__ + "static/media/wulkan.3c108f80.png";